export const GET_CLIENTES_USUARIO = 'GET_CLIENTES_USUARIO';
export const LOGIN_USUARIO = 'LOGIN_USUARIO';
export const LOGOUT_USUARIO = 'LOGOUT_USUARIO';
export const GET_SERVICIOS_TO_CLIENT = 'GET_SERVICIOS_TO_CLIENT';
export const GET_TAREAS_TO_SERVICIO = 'GET_TAREAS_TO_SERVICIO';
export const START_LOADING_SERVICIOS = 'START_LOADING_SERVICIOS';
export const FINISH_LOADING_SERVICIOS = 'FINISH_LOADING_SERVICIOS';
export const START_LOADING_CLIENTES = 'START_LOADING_CLIENTES';
export const FINISH_LOADING_CLIENTES = 'FINISH_LOADING_CLIENTES';
export const START_LOADING_TAREAS = 'START_LOADING_TAREAS';
export const FINISH_LOADING_TAREAS = 'FINISH_LOADING_TAREAS';   
export const LIMPIAR_SERVICIOS = 'LIMPIAR_SERVICIOS';
export const LIMPIAR_TAREAS = 'LIMPIAR_TAREAS';
export const CARGAR_HORAS = 'CARGAR_HORAS';
export const CARGAR_HORAS_EXITO = 'CARGAR_HORAS_EXITO';
export const CARGAR_HORAS_ERROR = 'CARGAR_HORAS_ERROR';
export const ACTUALIZAR_HORAS = 'ACTUALIZAR_HORAS';
export const CARGAR_HORAS_USUARIO = 'CARGAR_HORAS_USUARIO';
export const ACTUALIZAR_HORAS_USUARIO_LOGIN = 'ACTUALIZAR_HORAS_USUARIO_LOGIN';
// RESET_STATE y RESETEAR_HORAS removidos - no se utilizan
export const ELIMINAR_HORAS = 'ELIMINAR_HORAS';
export const GET_TAREAS_DEFAULT = 'GET_TAREAS_DEFAULT';
export const SET_TAREAS_DEFAULT = 'SET_TAREAS_DEFAULT';
export const LIMPIAR_HORAS = 'LIMPIAR_HORAS';
export const ACTUALIZAR_ESTADO_TARJETAS = 'ACTUALIZAR_ESTADO_TARJETAS';
export const OBTENER_HORAS = 'OBTENER_HORAS';
export const GET_TODAS_TAREAS = 'GET_TODAS_TAREAS';
export const SET_HORAS_REPORTE = 'SET_HORAS_REPORTE';  
export const SET_USUARIOS = 'SET_USUARIOS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CLEAR_HORAS = 'CLEAR_HORAS';
export const DATO_USUARIO = 'DATO_USUARIO';
export const GET_TODOS_CLIENTES = 'GET_TODOS_CLIENTES';
export const GET_TODAS_AREAS = 'GET_TODAS_AREAS';
export const HABILITAR_HORAS = 'HABILITAR_HORAS';
export const OBTENER_ESTADO_HORAS_HABILITADAS= 'OBTENER_ESTADO_HORAS_HABILITADAS';
export const CREAR_CLIENTE= 'CREAR_CLIENTE';
export const GET_SERVICIOS_TO_AREA_CLIENT= 'GET_SERVICIOS_TO_AREA_CLIENT';

// ========== ACTIONS PARA MIS HORAS DEL USUARIO LOGUEADO ==========
export const GET_MIS_HORAS_MES_ACTUAL = 'GET_MIS_HORAS_MES_ACTUAL';
export const GET_MIS_HORAS_POR_CLIENTE = 'GET_MIS_HORAS_POR_CLIENTE';
export const GET_MIS_HORAS_POR_SEMANA = 'GET_MIS_HORAS_POR_SEMANA';
export const GET_MIS_HORAS_POR_FECHA = 'GET_MIS_HORAS_POR_FECHA';
export const GET_MIS_HORAS_RESUMEN = 'GET_MIS_HORAS_RESUMEN';
export const LOADING_MIS_HORAS = 'LOADING_MIS_HORAS';
export const ERROR_MIS_HORAS = 'ERROR_MIS_HORAS';
export const CLEAR_MIS_HORAS = 'CLEAR_MIS_HORAS';

// ========== ACTIONS PARA REPORTE DE USUARIO ==========
export const GET_HORAS_REPORTE_USUARIO = 'GET_HORAS_REPORTE_USUARIO';
export const GET_HORAS_REPORTE_TODOS_USUARIOS = 'GET_HORAS_REPORTE_TODOS_USUARIOS';
export const LOADING_REPORTE_USUARIO = 'LOADING_REPORTE_USUARIO';
export const ERROR_REPORTE_USUARIO = 'ERROR_REPORTE_USUARIO';
export const CLEAR_REPORTE_USUARIO = 'CLEAR_REPORTE_USUARIO';

// ========== ACTIONS PARA REPORTE DE CLIENTES ==========
export const GET_HORAS_REPORTE_CLIENTE = 'GET_HORAS_REPORTE_CLIENTE';
export const GET_HORAS_REPORTE_TODOS_CLIENTES = 'GET_HORAS_REPORTE_TODOS_CLIENTES';
export const LOADING_REPORTE_CLIENTE = 'LOADING_REPORTE_CLIENTE';
export const ERROR_REPORTE_CLIENTE = 'ERROR_REPORTE_CLIENTE';
export const CLEAR_REPORTE_CLIENTE = 'CLEAR_REPORTE_CLIENTE';

// ========== ACTIONS PARA REPORTE DE ÁREA ==========
export const GET_HORAS_REPORTE_AREA = 'GET_HORAS_REPORTE_AREA';
export const LOADING_REPORTE_AREA = 'LOADING_REPORTE_AREA';
export const ERROR_REPORTE_AREA = 'ERROR_REPORTE_AREA';
export const CLEAR_REPORTE_AREA = 'CLEAR_REPORTE_AREA';